
/***
Process Forms
***/

jQuery(document).ready(function($){

/***************** Set Variables ******************/

var maxSize = '2000000'; // 2Mb
var maxSizeMb = parseFloat(maxSize / 1000000).toFixed(2) + 'Mb';; // 2Mb

/***************** Set visible max size ******************/

if ($('#max-file-size').length) {
  $('#max-file-size').html(maxSizeMb);
}

/***************** Show/Hide Image Uploader ******************/

$('#account_image_show').change(function() {
  console.log(this.value);
  if(this.checked) {
    var bgUrl = $('#image-upload-preview').data('custom-bg');
    $('#image-upload-preview').css('background-image','url('+ bgUrl +')');
  } else {
    var bgUrl = $('#image-upload-preview').data('default-bg');
    $('#image-upload-preview').css('background-image','url('+ bgUrl +')');
  }
});

/*if ($('#account_image_show:checked').length) {
  console.log('is checked');
  $('#custom-image-wrapper').removeClass('hide');
}*/

/***************** Require password match if not empty on Edit Account ******************/

	$('#edit-account-form').on('keyup','#password',function() {
		if ($('#edit-account-form #password').val().length) {
			console.log('changed');
			$('#password_2').attr('required','');
			$('.password_2-container').find('.required').removeClass('hide');
		} else {
			$('#password_2').removeAttr('required');
			$('.password_2-container').find('.required').addClass('hide');
		}
	});

/***************** Require password match if not empty on Edit Account ******************/
  var currentEmail = $('#edit-account-form #account_email').data('default');
	$('#edit-account-form').on('keyup','#account_email',function() {
		if ($('#edit-account-form #account_email').val()!=currentEmail) {
			$('#account_email_confirm').attr('data-equalto','account_email');
			$('#account_email_confirm').attr('required','');
			$('#confirm-email-wrapper').removeClass('hide');
		} else {
			$('#account_email_confirm').removeAttr('data-equalto');
			$('#account_email_confirm').removeAttr('required');
			$('#confirm-email-wrapper').addClass('hide');
		}
	});

/***************** Check filetype/size of upload and show preview ******************/

$("#account_image").change(function () {
        if (typeof (FileReader) != "undefined") {
            var imgPreview = $("#image-upload-preview");
            var regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.gif|.png|.bmp)$/;
            $($(this)[0].files).each(function () {
                var file = $(this);
                var fileSize = file[0].size;
                var fileSizeMb = parseFloat(fileSize / 1000000).toFixed(2) + 'Mb';
                //fileSizeMb = fileSizeMb.toFixed(2);
                console.log(file);
                if (file[0].size > maxSize) {
                  alert(file[0].name + " is too large a file (" + fileSizeMb + ").  Max size allowed is " + maxSizeMb + ".");
                } else {
                  if (regex.test(file[0].name.toLowerCase())) {
                      var reader = new FileReader();
                      reader.onload = function (e) {
                          var bg = e.target.result;
                          imgPreview.css({'background-image':'url(' + bg + ')','color':'#fff'});
                      }
                      reader.readAsDataURL(file[0]);
                  } else {
                      alert(file[0].name + " is not a valid image file.");
                      return false;
                  }
                }
            });
        } else {
            alert("This browser does not support HTML5 FileReader.");
        }
    });

/***************** Frontend Edit Account Submit ******************/

  $('.save-account').on('click',function(e) {
    e.preventDefault();
    $('#edit-account-form').submit();
    console.log('edit account clicked');
  });

  $('#edit-account-form').on('submit',function(e) {
    console.log('edit account form submitted');
    e.preventDefault();
  });

  function accountButtonSubmitting(buttonElement) {
    $(buttonElement).find('span').css('width', $(buttonElement).find('span').width() + 'px');
    buttonElement.addClass('spinner');
    buttonElement.find('span').text('Saving...');
  }

  function accountButtonResetting(buttonElement) {
    buttonElement.removeClass('spinner');
    buttonElement.find('span').text(buttonElement.data('default-text'));
  }

  var redirectURL = '';
  $(document).on('formvalid.zf.abide','#edit-account-form', function(e) {
    console.log('edit account form submitted');
    var submitButton = $(this).find('.save-account');
    accountButtonSubmitting(submitButton);
    var form = ('#edit-account-form');
    var data = new FormData();
     $.each($(':input:not(:checkbox, :radio)', form ), function(i, fileds){
         data.append($(fileds).attr('name'), $(fileds).val());
     });
     $('form').find(':checkbox:checked, :radio:checked').each(function () {
        data.append(this.name, $(this).val());
    });
     $.each($('input[type=file]',form )[0].files, function (i, file) {
         data.append(file.name, file);
     });

    /***************** Submit Form Data ******************/
    $.ajax({
       data: data,
       cache: false,
       contentType: false,
       processData: false,
       enctype: 'multipart/form-data',
       type: 'POST',
       url: ajaxurl,
       dataType: 'JSON',
       complete: function(data) {
         data = $.parseJSON(data.responseText);
         //console.debug(data);

         if (data['status'] != "success") {
  				 $('#error-response-msg').html(data['msg']);
           $('#edit-account-form-wrapper').find('.email-failure').fadeIn( function() {
             $(this).delay(2500).fadeOut('slow');
           });
           accountButtonResetting(submitButton);
         } else {
           //console.log('completed: ' + data['redirect']);
           //console.log('completed: ' + data.redirect);
           location.href = data['redirect'];
         }
       }
    });
  });


});
